import React from 'react'
import { BANKING_BOTTOM_CONTENT, SOFTWARE_COURSE_PAGE_5, SOFTWARE_DETAILS_PAGE_5, SOFTWARE_HERO_PAGE_5 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'
import { SOFTWARE_ACCORDIAN_5 } from '../../../utils/courseConifg'

const SoftwarePage_5 = () => {
  return (
    <div className='outlet-render'>
        <CourseAsideHero  {...SOFTWARE_HERO_PAGE_5}/>
     <CoursesAside {...SOFTWARE_COURSE_PAGE_5}/>
     <CourseCard {...SOFTWARE_DETAILS_PAGE_5}/>
     <Accordian {...SOFTWARE_ACCORDIAN_5}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default SoftwarePage_5